import React, { Component, Fragment } from "react";

import { Form, Button, Input, Icon, Grid, Segment, List, Message } from 'semantic-ui-react'
import { uniqBy, groupBy  } from 'lodash';

import Login from '../components/Login';
import SearchBar from '../components/SearchBar';
import test_edge3 from '../test_edge3.json';

import SigmaVis from '../components/SigmaVis';
import GraphVis from '../components/GraphVis';
import Graph from 'react-graph-vis';

import axios from 'axios';

const myGraph = {nodes:[{id:"n1", label:"A"}, {id:"n2", label:"B"}, {id:"n3", label:"C"}], edges:[{id:"e1",source:"n1",target:"n2",label:"SEES"}, {id:"e2",source:"n2",target:"n3",label:"SEES"}]};

// For SigmaVis use source/target and label, for GraphVis use from/to and title

const ETHER_API_PATH = "https://api.etherscan.io/api?module=account&action=txlist"
const ETHER_ADDRESS = "0xddbd2b932c763ba5b1b7ae3b362eac3e8d40121a"
const ETHER_API_KEY = "apikey=GRHRXF34HFU56GE75DEMBPIQTNNH3NFMQR"
const ETHER_URL = `${ETHER_API_PATH}&address=${ETHER_ADDRESS}&startblock=0&endblock=99999999&sort=asc&${ETHER_API_KEY}`
const XRATE = 1000000000000000000

const Placeholder = ({loading}) => (
  <Fragment>
    <Segment>
      {loading ? 'Loading...' : ' '}
      <div style={{height: '60vh'}}/>
    </Segment>
  </Fragment>
)

const json2File = (graph) => {
  const file = new Blob([JSON.stringify(graph)], {type : 'application/json'});
  return URL.createObjectURL(file)
}

function gri(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

class Console extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      address: false,
      data: false,
      queriedNodes: [],
      nodes: [],
      edges: [],
      graph: false,
      graphPath: false,
      selectedNode: false,
      newQuery: true
    };

    this.storeEdges = this.storeEdges.bind(this);
    this.storeNodes = this.storeNodes.bind(this);
    this.updateGraph = this.updateGraph.bind(this);
    this.queryTransactionsAPI = this.queryTransactionsAPI.bind(this);
    this.queryTokenName = this.queryTokenName.bind(this);
    this.triggerUpdate = this.triggerUpdate.bind(this);
    this.updateQueriedNodes = this.updateQueriedNodes.bind(this);
    this.downloadJSON = this.downloadJSON.bind(this)
  }

  storeEdges = (result) => {

    const { edges, newQuery } = this.state;
    this.setState({ data: result })
    const newEdges = [];
    for (let i in result) {
      let item = result[i];
      const edge = {id:item.hash, from: item.from, to: item.to, value: Number(item.value) / XRATE, label: item.value};
      newEdges.push(edge);
    }

    const processedEdges = [...newEdges.reduce((r, o) => {
      const key = o.from + '-' + o.to;
      const item = r.get(key) || Object.assign({}, o, {
        value: 0,
        label: 0,
        numTransactions: 0
      });
      item.value += o.value;
      item.label = (Math.round(item.value * 1000) / 1000).toString();
      item.numTransactions += 1;
      item.id = o.id;

      return r.set(key, item);
    }, new Map).values()];


    const oldEdges = newQuery
      ? []
      : edges;

    const updatedEdges = [
      ...oldEdges,
      ...processedEdges
    ];

    const uniqueEdges = uniqBy(updatedEdges, 'id');

    this.setState({ edges: uniqueEdges}, this.storeNodes)

  }

  storeNodes = () => {
    const { nodes, edges, queriedNodes, newQuery } = this.state;
    const newNodes = [];
    const newNodes2 = [];
    for (let i = 0; i < edges.length; i++) {
      newNodes.push({id:edges[i].from, title: edges[i].from });
      newNodes.push({id:edges[i].to, title: edges[i].to });
    }

    for (let i = 0; i < newNodes.length; i++) {
      const nodeColor = queriedNodes.includes(newNodes[i].id) ? "#ff9a02" : "#84b3ff"
      newNodes2.push({id:newNodes[i].id, title: newNodes[i].id, color: nodeColor});
    }

    const oldNodes = newQuery
      ? []
      : nodes;

    const updatedNodes = [
      ...newNodes2,
      ...oldNodes
    ];
    const uniqueNodes = uniqBy(updatedNodes, 'id')

    this.setState({ nodes: uniqueNodes }, () => this.updateGraph(uniqueNodes, this.state.edges));
  }

  onNodeClick = (e) => {
    const {nodes, edges} = e
    this.setState({ selectedNode: nodes[0] })
  }

  updateGraph = ( nodes, edges) => {
    const newGraph = {nodes:[...nodes], edges:[...edges]};
    this.setState({
      graph: newGraph,
      isLoading: false
    })
    console.log('update graph')
    console.log(newGraph)
    const filePath = json2File(newGraph);
    this.triggerUpdate(filePath)
  }

  triggerUpdate = (filePath) => {
    this.setState({ graphPath: filePath });
  }

  onChange = (event) => {
    this.setState({ address: event.target.value.toLowerCase() });
  }

  queryTransactionsAPI = (address) => {
    console.log('query transactions API:')
    console.log(address)
    axios.get(`${ETHER_API_PATH}&address=${address}&startblock=0&endblock=99999999&page=1&offset=1000&sort=asc&${ETHER_API_KEY}`, {
    }).then(response => response.data)
      .then(data => {
        this.updateQueriedNodes(address);
        return data
      }).then(data => this.storeEdges(data.result)
       ).catch(error => console.log(error))
  }

  queryTokenName = (address) => {
    console.log('query token name API:')
    console.log(address)
    axios.get(`${ETHER_API_PATH}&address=${address}&startblock=0&endblock=99999999&page=1&offset=2&sort=asc&${ETHER_API_KEY}`, {
    }).then(response => response.data)
      .then(data => data.result[0]['tokenName'])
      .catch(error => console.log(error))
  }


  updateQueriedNodes = (address) => {
    this.setState({ queriedNodes: [...this.state.queriedNodes, address] })
  }

  onSubmit = () => {
    const { address } = this.state;
    this.queryTransactionsAPI(address);
    this.setState({
      newQuery: true,
      isLoading: true
    });
    // this.setState({ data: test_edge3 })
    // this.updateGraph(test_edge3.nodes, test_edge3.edges);
  }

  onExpandNode = () => {
    this.queryTransactionsAPI(this.state.selectedNode);
    this.setState({
      newQuery: false,
      isLoading: true
    });
    // this.updateGraph(myGraph.nodes, myGraph.edges);
  }

  downloadJSON() {
    // Creates a temp a element to have a named download
    const { graph } = this.state;
    let saveData = (function () {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      return function (data, fileName) {
          let json = JSON.stringify(data),
          blob = new Blob([json], {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
      };
    }());

    let data = graph, fileName = "graph.json";
    saveData(data, fileName);
  }

  render() {
    const { isLoading, graphPath, data, nodes, edges, graph, selectedNode } = this.state

    const events = {
        select: e => this.onNodeClick(e)
    }


    return (
      <Fragment>
        <Form onSubmit={this.onSubmit} >
          <Input
            style = {{width: '80%'}}
            loading = {isLoading}
            icon={<Icon name='search' link onClick={this.onSubmit}/>}
            placeholder='Enter Address...'
            onChange={this.onChange} />
        </Form>
        <br/>
        <Grid divided columns='equal'>
          <Grid.Row stretched>
            <Grid.Column width={10}>
              {data && graphPath ?
                <Segment>
                  {/* <SigmaVis
                    nodes = {nodes}
                    edges = {edges}
                    graphPath = {graphPath}
                    onClickNode={e => this.onNodeClick(e)}
                  /> */}
                  <GraphVis graph={graph} events={events} loading={isLoading}/>
                </Segment>
              : <Placeholder loading={isLoading}/>}
            </Grid.Column>
            <Grid.Column width={4}>

              {data && graphPath ?
                (data && graphPath && selectedNode ?
                  <div style={{textAlign: 'left'}}>
                    <b>{selectedNode}</b>
                    <List>
                      <List.Item>Risk Score: {gri(10, 90)}</List.Item>
                      <List.Item>Total Value: {gri(0, 20)}</List.Item>
                      <List.Item>Degree: {gri(0,50)}</List.Item>
                      <List.Item>Centrality: {gri(10,100)/100}</List.Item>
                      <List.Item>Number of transactions in last month: {gri(0,20)}</List.Item>
                      <List.Item>Number of transactions in last year: {gri(20,100)}</List.Item>
                    </List>

                    <Button color="blue" fluid size="medium" onClick= {() => this.onExpandNode()}>
                      Expand Node
                    </Button>
                    <br/>
                    <Button color="green" fluid size="medium">
                      Explore in LynxKite
                    </Button>
                    <Button color="blue" fluid size="medium" onClick= {() => this.downloadJSON()} style={{position: 'absolute', bottom:0}}>
                      Export graph as Json
                    </Button>
                  </div> :
                <div style={{textAlign: 'left'}}>
                <b>Select a node to get started</b>
                <Button color="blue" fluid size="medium" onClick= {() => this.downloadJSON()} style={{position: 'absolute', bottom:0}}>
                  Export graph as Json
                </Button>
                </div>
            ) :
              false}

            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Message> Powered by LynxKite. Scam data from Etherscamdb and Etherscan.  </Message>
      </Fragment>
    );
  }
}

export default Console;
